import { NewAnomalyItem } from '../utils/models';
import httpService from './httpService';

interface Response {
    message: string;
    data: {
        anomalies: NewAnomalyItem[];
        projectId: string;
        createdAt: string;
    };
}

class AnomalyService {
    saveAnomalyRecord(projectId: string, anomalyRecord: NewAnomalyItem[]) {
        const anomalies: NewAnomalyItem[] = anomalyRecord.map((anomaly) => ({
            id: anomaly.id,
            class: anomaly.class,
            location: anomaly.location,
            generalImage: anomaly.generalImage,
            closeImage: anomaly.closeImage,
            description: anomaly.description.map((description) => ({
                label: description.label,
                value: description.value,
            })),
            recommendation: anomaly.recommendation.map((recommendation) => ({
                label: recommendation.label,
                value: recommendation.value,
            })),
        }));

        return httpService.post<Response>('/anomaly', { projectId, anomalies }).then(response => response.data);
    }

    getAnomalyRecords(projectId: string) {
        return httpService.get<Response>('/anomaly/' + projectId).then((response) => response.data);
    }
}

const anomalyService = new AnomalyService();
export default anomalyService;
